import { apiClient } from "@/lib/api-client";
import type { paths } from "@/lib/api-types";
import { listQueryOptions } from "./hooks";

export type AdminPaymentListItem =
  paths["/api/admin/payments"]["get"]["responses"]["200"]["content"]["application/json"]["data"][number];

type AdminPaymentsListQuery = {
  limit?: number;
  page?: string;
};

export function useAdminPaymentsList(params: AdminPaymentsListQuery = {}) {
  return apiClient.useQuery(
    "get",
    "/api/admin/payments",
    {
      params: {
        query: {
          limit: params.limit ?? 50,
          ...(params.page ? { page: params.page } : {}),
        },
      },
    },
    listQueryOptions,
  );
}
